
import React from "react";
import {transactionCode} from "../Const/TranscationCode";

const LabelTranscation=(props)=>{
    const filter=transactionCode.filter((item)=>item.key===props.value);
    if(filter.length==1){
        return <div className={"badge badge-light-" + (filter[0].color)}>{(filter[0].label)}</div>
    }   
    return ''
}
export default LabelTranscation;